import { useMediaQuery } from "@mui/material";

export const useIsExtraLargeScreen = () => useMediaQuery("@media (min-width:1440px)");